// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyNotice_qmee_root__OUvsH"};